<div class="sb-form-block__fields" [formGroup]="addressFormGroup">
  <div class="row" *ngIf="shouldShowRecipient">
    <div class="col-xs-12 " [ngClass]=" shouldShowAtField ? 'col-tb-6' : ''">
      <div class="sb-form-block__field">
        <wt-input-text [validateOnBlur]="true" type="text" label="{{'ENTITY.ADDRESS.RECIPIENT' | translate}}" formControlName="recipient"></wt-input-text>
      </div>
    </div>
    <div class="col-xs-12 col-tb-6" *ngIf="shouldShowAtField">
      <div class="sb-form-block__field">
        <wt-input-text [validateOnBlur]="true" type="text" [maxLength]="FormConstants.MAXIMUM_ADDRESS_AT_LENGTH" label="{{'ENTITY.ADDRESS.AT' | translate}}" formControlName="at"></wt-input-text>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 col-tb-4" *ngIf="shouldShowCountries">
      <div class="sb-form-block__field">
        <wt-input-select-autocomplete
          [items]="countriesAutocompleteInputOptions"
          bindLabel="name"
          bindValue="id"
          [label]="'ENTITY.ADDRESS.COUNTRY' | translate"
          [notFoundText]="'ENTITY.ADDRESS.COUNTRY.NOT-FOUND' | translate"
          formControlName="country"></wt-input-select-autocomplete>
      </div>
    </div>
    <div class="col-xs-12" [ngClass]=" shouldShowCountries ? 'col-tb-6' : 'col-tb-10'">
      <div class="sb-form-block__field">
        <wt-input-text lastPassHandler [validateOnBlur]="true" type="text" [maxLength]="FormConstants.MAXIMUM_ADDRESS_STREET_LENGTH" label="{{'ENTITY.ADDRESS.STREET' | translate}}" formControlName="street"></wt-input-text>
      </div>
    </div>
    <div class="col-tb-2 col-xs-6">
      <div class="sb-form-block__field">
        <wt-input-text [validateOnBlur]="true" type="text" [maxLength]="FormConstants.MAXIMUM_ADDRESS_NUMBER_LENGTH" label="{{'ENTITY.ADDRESS.NUMBER' | translate}}"  formControlName="number"></wt-input-text>
      </div>
    </div>
    <div class="col-tb-2 col-xs-6">
      <div class="sb-form-block__field">
        <wt-input-text lastPassHandler
          type="numeric"
          [validateOnBlur]="true"
          [maxLength]="FormConstants.MAXIMUM_ZIP_CODE_LENGTH"
          (keyupChange)="searchZipOnUserInputSubject.next($event)"
          label="{{'ENTITY.ADDRESS.ZIP' | translate}}"
          formControlName="zipCode"
        >
        </wt-input-text>
      </div>
    </div>
    <div class="col-tb-10 col-xs-12">
      <div class="sb-form-block__field">
        <wt-input-select-autocomplete
          formControlName="city"
          bindLabel="fullName"
          bindValue="city"
          [notFoundText]="'ENTITY.ADDRESS.CITY.PLACEHOLDER' | translate"
          [label]="'ENTITY.ADDRESS.CITY' | translate"
          [disabled]="cityAutocompleteInputDisabled"
          [loading]="cityAutocompleteInputLoading"
          [items]="cityAutocompleteInputOptions"
          (search)="searchCitiesOnUserInputSubject.next($event)"
          (change)="fillDistrictFromCityModel($event)"
        >
        </wt-input-select-autocomplete>
      </div>
    </div>
  </div>
</div>
